import { isEqual } from "lodash";
import { useState } from "react";
import { DaysPendingQuickFilter } from "./interfaces";

export const useDaysPendingQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<DaysPendingQuickFilter>({
    daysPending: {
      days: 0,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof DaysPendingQuickFilter,
    value: DaysPendingQuickFilter["daysPending"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    daysPendingQuickFilter: quickFilter,
    setDaysPendingQuickFilter: handleChangeQuickFilter,
  };
};
